import styled from 'styled-components';
import { theme } from '../../../../../styles/theme';

type ColumnProps = {
  columnSize: string;
};

export const StyledRow = styled.tr.attrs({
  className: 'row',
})`
  display: flex;
`;

export const StyledColumn = styled.td.attrs<ColumnProps>((props) => ({
  className: `${props.columnSize}`,
}))<ColumnProps>`
  border: 0px;
`;

export const ModalFooter = styled.div`
    height: 60px;
    display: flex;
    flex-direction: row-reverse;
    background-color: #F0F0F0};
`;

export const ModalReactivateButton = styled.input.attrs(() => ({
  className: 'btn',
}))`
  background: ${theme.palette.rebeccaPurple};
  height: 40px;
  margin-top: auto;
  margin-bottom: auto;
  margin-right: 16px;
  color: ${theme.palette.white};
  font-weight: ${theme.typography.fontWeights.semibold};
`;
